import { ProductDisplayData } from 'types/ProductTypes';
import {
  formatItalianPercentage,
  formatItalianPercentageNo100,
  formatItalianNumber,
  formatItalianCurrency,
} from 'utils/formatUtils';

// Vincoli Invia recap delegates all numeric formatting to the shared Italian
// formatters in `utils/formatUtils` — the same ones the fineco portfolio
// artifact uses, so the recap and the artifact display the same fields the
// same way.

/** Render a 0..1 ratio as an Italian percentage (multiplied by 100). */
export function formatPercent(value: number): string {
  return formatItalianPercentage(value);
}

/** Render a number already in percent units (e.g. VaR stored as 12.6 = 12.6%). */
export function formatPercentRaw(value: number): string {
  return formatItalianPercentageNo100(value);
}

/** Render a non-percent number with Italian decimal separator (2 decimals). */
export function formatNumber(value: number): string {
  return formatItalianNumber(value);
}

/** Render an euro amount via the shared Italian currency formatter (same as CostiTable). */
export function formatCurrency(value: number): string {
  return formatItalianCurrency(value);
}

/** Render a boolean via the project's existing Sì/No translation keys. */
export function formatBoolean(
  value: boolean,
  t: (key: string) => string,
): string {
  return value ? t('constraints.yes') : t('constraints.no');
}

/**
 * Render an ISIN row label as the product NAME only. The ISIN is dropped from
 * the recap so each product fits on a single line — falls back to the bare
 * ISIN when display data hasn't loaded yet (better than rendering nothing).
 */
export function formatProductLabel(
  isin: string,
  display: ProductDisplayData | undefined,
): string {
  return display?.label ?? isin;
}
